// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"78e77ff3","455":"389b4687","821":"d2ade867","977":"b3362d2a"}[chunkId] + ".chunk.js";
};